import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import { BackendService } from '../backend/backend.service';

export interface IOwnershipValidationPayload {
    accountNumber: string;
    bank: number;
    branch: number;
    documentNumber: string;
}

export interface IOwnershipValidationResultValue {
    transactionId: string;
    isAccountOwner: boolean;
    status: string;
    message: string | null;
}

export interface IOwnershipValidationResponse {
    value: IOwnershipValidationResultValue;
    hasValue: boolean;
    messages: any[];
    hasWarning?: boolean;
    hasAlerta?: boolean;
    hasError?: boolean;
    hasInfo?: boolean;
    ok: boolean;
}

export class OwnershipInvalidError extends Error {
    public readonly isOwnershipInvalid = true;
    constructor(public readonly backendMessage: string | null, public readonly transactionId?: string) {
        super(backendMessage || 'Titularidade invalida');
        Object.setPrototypeOf(this, OwnershipInvalidError.prototype);
    }
}

@Injectable({ providedIn: 'root' })
export class BankAccountOwnershipService {
    private static readonly ENDPOINT = 'v2/users/bank-account/validate';
    private static readonly REQUEST_TIMEOUT_MS = 15000;

    constructor(private backendService: BackendService) {}

    public validateOwnership(payload: IOwnershipValidationPayload): Observable<IOwnershipValidationResultValue> {
        return this.backendService.post<IOwnershipValidationResponse>(BankAccountOwnershipService.ENDPOINT, payload).pipe(
            timeout(BankAccountOwnershipService.REQUEST_TIMEOUT_MS),
            map((response) => {
                const value = response && response.value;
                if (!value) {
                    throw new OwnershipInvalidError(null);
                }
                if (value.isAccountOwner === false) {
                    throw new OwnershipInvalidError(value.message, value.transactionId);
                }
                return value;
            }),
        );
    }
}
